import * as styles from "./agenda/styles"
import { useDateTime } from "./agenda/utils"
import {Column, Row} from "./agenda/layout"
import { useRef, useState, useEffect } from "preact/hooks"


export const AgendaSidebar = ({events, triggerAt = []}) => {
	const now = useDateTime()

	const column = useRef(null)
	const [actual, setActual] = useState(null)
	const [sessions, setSessions] = useState(events)
	const [day, setDay] = useState(new Date().toISOString().split("T")[0])

	const startDt = new Date(events[0].start)
	const endDt = new Date(events[events.length - 1].start)
	
	triggerAt.forEach(t => {
		const [[startTrigger, endTrigger], event] = t
		if (now >= startTrigger && now <= endTrigger) event()
	})

	let dt = new Date()
	if (now < startDt) dt = startDt
	else if (now > endDt) dt = endDt

	if (day !== dt.toISOString().split("T")[0]) setDay(dt.toISOString().split("T")[0])

	useEffect(() => {
		const active = sessions.map(isPastPresentFuture).find(x => x.active)
		if (!actual || active.id !== actual.id) setActual(active);
	}, [now])

	useEffect(() => {
		let start = new Date(`${day} 00:00:00`)
		let end = new Date(`${day} 23:59:59`)

		setSessions(events.filter(ev => new Date(ev.start) >= start && new Date(ev.start) < end))
	}, [day])

	useEffect(() => {
		if (column.current === null) return;
		const active = column.current.base.getElementsByClassName("active-ev")
		
		if (active.length === 0) return;
		column.current.base.scrollTop = active[0].offsetTop - column.current.base.offsetTop;
	}, [actual])

	const baseStyle = {
		...styles.fstart,
		textDecoration: "none",
		fontSize: ".8em",
		marginBottom: "10px",
		lineHeight: 1.2,
	}
	const rowStyles = [
		{
			...baseStyle,
			color: "#888",
		},{
			...baseStyle,
			fontWeight: "bold",
			color: "#3c1d4a",
		},{
			...baseStyle,
			color: "#3c1d4a",
		}
	]

	const isPastPresentFuture = (event, i, arr) => {
		const start = new Date(event.start)
		const end = new Date(event.end)
		const farEnd = new Date(new Date(event.end).valueOf() + 7200000)
		if (now > farEnd) return {
			...event,
			style: {display: "none"},
		}

		if (now > end) return {
			...event,
			style: rowStyles[0]
		}
		else if (now > start && now < end) return {...event, active: true, style: rowStyles[1]}
		else if (now < start) return {...event, active: false, start, end, style: rowStyles[2]}
	}

	return <Column ref={column} class="breakout-agenda" styleOverride={{
		overflowX: "hidden",
		overflowY: "scroll",
		scrollbarWidth: "none",
		maxHeight: "100%",
		height: "100%",
		padding: "10px"
	}}>
		{sessions.map(isPastPresentFuture).map(event => {
			const start = new Date(event.start)

			return <Row styleOverride={event.style} className={event.active ? "active-ev" : undefined}>
				<span class="agenda-time">
					{start.getHours() >= 10 ? start.getHours() : `0${start.getHours()}`}:{start.getMinutes() > 10 ? start.getMinutes() : `0${start.getMinutes()}`}
				</span>
				<span class="agenda-item" style={{marginLeft: "10px"}}>
					{event.title}
				</span>
			</Row>
		})}
	</Column>
}